// Betreiberangaben eines Platzes zum Anzeigen (App). Zwilling: lib/spot-extra.js (öffentliche Platzseite);
// test/spot-extra.test.mjs hält beide gleich. Liefert nur Schlüssel und Werte — Texte und Zahlenformat setzt der Aufrufer.

/** Aktueller Hinweis des Betreibers oder null (abgelaufen, wenn notice_until vor heute liegt). */
export function noticeActive(info, today) {
  if (!info || !info.notice) return null;
  if (info.notice_until && String(info.notice_until) < String(today)) return null;
  return info.notice;
}

/** Zeilen für Anreise, Mittagsruhe, Fahrzeuglänge, Gespanne, Tandemachser: [{ key, icon, vars }]. */
export function infoRows(info) {
  const i = info || {};
  const out = [];
  if (i.arrival_from && i.arrival_to) out.push({ key: 'arrival', icon: 'login', vars: { from: i.arrival_from, to: i.arrival_to } });
  else if (i.arrival_from) out.push({ key: 'arrival_from', icon: 'login', vars: { from: i.arrival_from } });
  else if (i.arrival_to) out.push({ key: 'arrival_to', icon: 'login', vars: { to: i.arrival_to } });
  if (i.quiet_from && i.quiet_to) out.push({ key: 'quiet', icon: 'bedtime', vars: { from: i.quiet_from, to: i.quiet_to } });
  if (Number(i.max_length_m) > 0) out.push({ key: 'max_length', icon: 'straighten', vars: { m: Number(i.max_length_m) } });
  if (i.trailers_ok === true || i.trailers_ok === false) out.push({ key: i.trailers_ok ? 'trailers_yes' : 'trailers_no', icon: 'rv_hookup', vars: {} });
  if (i.tandem_ok === true || i.tandem_ok === false) out.push({ key: i.tandem_ok ? 'tandem_yes' : 'tandem_no', icon: 'local_shipping', vars: {} });
  return out;
}

